import { textStyle } from "@passfirst/ui";

import type { Colors } from "../theme";

// Markdown styling for tutor assistant bubbles. Sonnet emits **bold**,
// *italic*, ---, blockquotes, and tables; without a renderer these
// leak as raw characters in the bubble. Factory because the theme can
// flip; the tutor panel rebuilds the map via useMemo on theme change.
export function makeTutorMarkdownStyles(colors: Colors) {
  return {
    body: { ...textStyle.body, color: colors.textPrimary },
    heading1: { ...textStyle.body, fontWeight: "700" as const, marginTop: 8 },
    heading2: { ...textStyle.body, fontWeight: "700" as const, marginTop: 8 },
    heading3: { ...textStyle.body, fontWeight: "700" as const, marginTop: 6 },
    strong: { fontWeight: "700" as const },
    em: { fontStyle: "italic" as const },
    bullet_list: { marginVertical: 4 },
    ordered_list: { marginVertical: 4 },
    list_item: { marginBottom: 2 },
    hr: {
      backgroundColor: colors.border,
      height: 1,
      marginVertical: 8,
    },
    blockquote: {
      backgroundColor: colors.surfaceMuted,
      borderLeftColor: colors.border,
      borderLeftWidth: 3,
      paddingHorizontal: 8,
      paddingVertical: 4,
      marginVertical: 4,
    },
    code_inline: {
      backgroundColor: colors.surfaceMuted,
      paddingHorizontal: 4,
      borderRadius: 3,
      fontFamily: "monospace",
    },
    fence: {
      backgroundColor: colors.surfaceMuted,
      padding: 8,
      borderRadius: 4,
      fontFamily: "monospace",
      marginVertical: 4,
    },
    table: {
      borderWidth: 1,
      borderColor: colors.border,
      marginVertical: 4,
    },
    thead: { backgroundColor: colors.surfaceMuted },
    th: { padding: 4, fontWeight: "700" as const },
    td: { padding: 4 },
    link: {
      color: colors.textBrand,
      textDecorationLine: "underline" as const,
    },
  };
}
